// extracted by mini-css-extract-plugin
module.exports = {"main":"dateSelectMobile_main__AniBC"};